import React from 'react';

const countries = [
  { name: 'India', code: 'in' },
  { name: 'United Kingdom', code: 'gb' },
  { name: 'United States', code: 'us' },
  { name: 'Japan', code: 'jp' },
  { name: 'Australia', code: 'au' },
  { name: 'Zimbabwe', code: 'zw' },
  {name:'poland', code:'pl'}
];

const CountryFlags = () => {
  return (
    <div className="flags-fixed-wrapper">
      <div className="vertical-heading">OUR PRESENCE</div>
      <div className="flags-fixed-container">
        {countries.map((country) => (
          <div className="flag-circle" key={country.code} title={country.name}>
            <img
              src={`https://flagcdn.com/${country.code}.svg`}
              alt={country.name}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CountryFlags;
